export const militaryDischargeOptions = [
  'Honorable',
  'Dishonorable',
  'LessThan',
  'General',
  'BadConduct',
  'Other',
];

export const militaryDischargeOptionsPvq = [
  'Honorable',
  'General',
  'OtherThan',
  'Dismissal',
  'BadConduct',
  'Dishonorable',
  'OtherType',
];
